import ChannelContent from "./ChannelContent";
import ChannelViewMaxHeader from "./ChannelViewMaxHeader";

const ChannelViewMax = () => {
  return (
    <>
     
        <ChannelViewMaxHeader />
        <ChannelContent/>
    </>
  );
};

export default ChannelViewMax;
